import React, { Component } from "react";

export default class HeroImage extends Component {
  render() {
    const { language } = this.props;
 // style={{ backgroundImage: 'url("./assets/images/fill.jpg")' }}
    return (
      <header>
          <div className="headerInside">
            <picture>
            <source
                    media="(max-width: 1024px) "
                    srcSet={"./assets/images/bg.jpg"}
                  />
                      <source
                    media="(max-width: 1400px) "
                    srcSet={"./assets/images/bg_tablet.jpg"}
                  />
                        <source
                    media="(max-width: 1620px)"
                    srcSet={"./assets/images/bg_slim.jpg"}
                  />
              <img src="./assets/images/bg_xl.jpg" alt="Hero" />
            </picture>
          </div>
      </header>
    );
  }
}
